import React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { formatCalendarDate, getMessage } from "../i18n/locale";
import { availabilityKey, normalizeAvailability } from "../services/availability";

export default function AvailabilityList({ availability, locale, timeZone }) {
  const entries = normalizeAvailability(availability, timeZone);
  if (!entries.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {getMessage(locale, "availabilityEmpty")}
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
      {entries.slice(0, 8).map((entry, index) => {
        const start = formatCalendarDate(entry.startDate, { locale });
        const end = formatCalendarDate(entry.endDate, { locale });
        const dates = entry.startDate === entry.endDate ? start : `${start} – ${end}`;
        const statusColors = {
          AVAILABLE: { light: "#1B5E20", dark: "#A5D6A7", lightBg: "#E8F5E9", darkBg: "rgba(46, 125, 50, .24)" },
          TENTATIVE: { light: "#7A4F00", dark: "#FFE082", lightBg: "#FFF8E1", darkBg: "rgba(255, 179, 0, .20)" },
          UNAVAILABLE: { light: "#58616D", dark: "#D5D9DE", lightBg: "transparent", darkBg: "transparent" },
        }[entry.state];
        return (
          <Chip
            key={availabilityKey(entry, index)}
            icon={<CalendarMonthIcon />}
            color={entry.state === "AVAILABLE" ? "success" : entry.state === "TENTATIVE" ? "warning" : "default"}
            variant={entry.state === "UNAVAILABLE" ? "outlined" : "filled"}
            label={`${dates} · ${getMessage(locale, `availabilityState${entry.state}`)}`}
            title={entry.notes || entry.timeZone}
            size="small"
            sx={(theme) => ({
              color: theme.palette.mode === "dark" ? statusColors.dark : statusColors.light,
              bgcolor: theme.palette.mode === "dark" ? statusColors.darkBg : statusColors.lightBg,
              border: "1px solid",
              borderColor: "currentColor",
              "& .MuiChip-icon": { color: "inherit" },
            })}
          />
        );
      })}
    </Stack>
  );
}
